
import { MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import { PropTypes } from 'prop-types';
const Gallery = ({ imgs }) => {

    return (
        <div className='grid grid-cols-1 md:grid-cols-2  xl:grid-cols-4  gap-4 h-fit lg:h-[60rem] xl:h-[40rem] w-full '>
            {
                imgs?.map((img, index) => {
                    return (
                        <div key={index} className={"w-full h-[25rem] lg:h-full relative bg-cover bg-center bg-no-repeat  " + img.css} style={{ backgroundImage: `url('${img.img}')` }}>
                            <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black"></div>
                            <div className="absolute bottom-0 left-0 w-full h-1/2 flex flex-col justify-end items-left gap-2 p-4">
                                <p className="text-white text-xs">{new Date(img.date).toLocaleDateString('en-US',
                                    {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    }

                                )}</p>
                                <h1 className="text-white text-2xl uppercase">{img.title}</h1>
                                {
                                    img.link &&
                                    <a href={img.link} target='_blank' rel="noreferrer" className="text-white flex items-center gap-1">See More <MdOutlineKeyboardDoubleArrowRight size={25} /> </a>

                                }
                            </div>
                        </div>
                    )
                })
            }

        </div>
    )
}
Gallery.propTypes = {
    imgs: PropTypes.array
}
export default Gallery